import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchHeatDiaryCycleEntries } from "actions/heat_diary";
import Section from "components/layout/Section";
import Message from "components/message";
import FetchEntries from "components/fetch";
import Table from "components/table_2";
import config from "./config";

class ViewEntries extends Component {
  handleFetchEntries = (value, unit, name) => {
    const { pet } = this.props;
    this.props.fetchHeatDiaryCycleEntries(value, unit, name, pet);
  };

  renderSectionContent() {
    const { heatDiary, messages, pet, defaultRoute } = this.props;
    const { entries } = heatDiary.cycles;
    const entriesFiltered = entries.filter((entry) => entry._pet === pet._id);

    // Create data set for table
    const tableData = {
      feature: "heatDiary",
      pet: pet._id,
      id: Date.now(),
      headers: config.tableView.cycles.headers,
      data: entriesFiltered,
      mobileHeaders: config.tableView.cycles.mobileHeaders,
      messages: {
        ...messages.filterBy,
      },
      filterByItems: [],
      filterKey: "",
      viewEntryTo: `${defaultRoute}/view_entry_cycle/`,
      fetchDates: heatDiary.cycles.fetchDates,
      fetchType: heatDiary.cycles.fetchType,
    };

    if (entriesFiltered.length === 0) {
      return <Message warning message={"noEntriesToDisplayRetry"} />;
    }

    return <Table tableData={tableData} itemsPerPage={5} />;
  }

  render() {
    const { fetchType, lastFetchPetID } = this.props.heatDiary.cycles;
    const { pet } = this.props;
    return (
      <>
        <FetchEntries
          fetchItems={this.handleFetchEntries}
          fetchType={fetchType}
          newPet={pet._id === lastFetchPetID}
          fetchButtons={["last7Days", "last30Days", "last3Months", "last1Year"]}
        />
        <Section>{this.renderSectionContent()}</Section>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      fetchHeatDiaryCycleEntries,
      dispatch,
    },
    dispatch
  ),
});

export default connect(null, mapDispatchToProps)(ViewEntries);
